import { useCallback, useEffect, useRef, useState } from 'react';

import { UseIsFocused } from './useIsFocused.types';

const useIsFocused: UseIsFocused = () => {
  const [isFocused, setIsFocused] = useState(false);
  const blurTimeout = useRef<number>();

  const onFocus = useCallback(() => {
    window.clearTimeout(blurTimeout.current);
    setIsFocused(true);
  }, []);

  const onBlur = useCallback(() => {
    blurTimeout.current = window.setTimeout(() => {
      setIsFocused(false);
    }, 0);
  }, []);

  useEffect(
    () => () => {
      window.clearTimeout(blurTimeout.current);
    },
    []
  );

  return {
    onFocus,
    onBlur,
    isFocused,
  };
};

export default useIsFocused;
